import ImportEntireRuleset from './ImportEntireRuleset';

export default ImportEntireRuleset;
